import _ from 'underscore';

import { openReactAlertDialog } from '~commonInfra/dialogs/ReactAlertDialog';
import { Formatters, Messages } from '~src/codegen/Localize';
import { ChangeTagsActionHelperService } from '~src/content/services/ChangeTagsActionHelper';
import { getCommonDatasourceInfo } from '~src/datasource/models/mappers/CommonDatasourceInfo';
import { DataSources } from '~src/datasource/resources/Datasources';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';
import { IContentInfo } from '~src/spacesPlatform/models/IContentInfo';
import { L10n } from '~src/ts/L10n/L10n';
import { INamedItemInfo } from '~src/ts/models/resourceInfoParts';
import { IChangeContentTagsResult } from '~src/ts/ServerApi/types/IChangeContentTagsAction';

export namespace ChangeContentTagsAction {

  function execute(items: IContentInfo[]): Promise<IChangeContentTagsResult> {
    return ChangeTagsActionHelperService.createExecuteFnForMixedContent({
      getDescription: (items: INamedItemInfo[]) => getDescription(items),
    })(items);
  }

  function getDescription(items: INamedItemInfo[]) {
    return (items.length === 1)
      ? Messages.changeTagsContentDescription({ NAME: L10n.elideIfLong(items[0].name) })
      : Messages.changeTagsPluralContentDescription({ COUNT_LOC: Formatters.formatCount(items.length) });
  }

  export function showChangeTagsForMixedContentDialog(content: IContentInfo[]): Promise<IResult> {
    if (allContentIsEmbeddedDatasources(content)) {
      return openReactAlertDialog({
        title: Messages.changeTagsDatasource_cannotTagAlertTitle(),
        message: Messages.changeTagsDatasource_cannotTagAlertMessage()
      }).result;
    }

    return execute(content);
  }

  function allContentIsEmbeddedDatasources(allContent: IContentInfo[]): allContent is IContentInfo<'datasource'>[] {
    return _.all(allContent, item =>
      item.contentType === 'datasource' && DataSources.isEmbedded(getCommonDatasourceInfo(item))
    );
  }
}

export type ChangeContentTagsAction = typeof ChangeContentTagsAction;
